export default "__VITE_ASSET__D5T3ipe0__"